import { generateBankLedgerPdfBlob } from "./generateBankLedgerPdf";

/**
 * Generates Girvi Bank Ledger PDF Blob using high-performance jsPDF + autotable.
 * Re-uses generateBankLedgerPdfBlob with title="Girvi Bank Ledger".
 */
export async function generateGirviBankLedgerPdfBlob(options = {}) {
  return generateBankLedgerPdfBlob({
    title: "Girvi Bank Ledger",
    ...options,
  });
}

export default generateGirviBankLedgerPdfBlob;

